import BaseFeature from '../../foundation/base/base';

class Search extends BaseFeature {
	constructor(element) {
		super(element);
		this.elm = element;
		this.localSearchPage = element.querySelector('[data-ss360-include]');
		this.burgermenu = element.querySelector('[data-ref="header__navController"]');

		const sortingOptionElement = element.querySelector('[data-sorting-option]');
		if (sortingOptionElement) {
			this.sortingOption = sortingOptionElement.getAttribute('data-sorting-option');
		}
		if (this.localSearchPage) {
			this.setEventListeners();
		}
		this.initDomCache();

		window.ss360Config = {
			tracking: {
				providers: [
					'GTM'
				],
				enhanced: false
			},
			dataPoints: {
				exclude: [],
				single: []
			},
			siteId: 'diabetes.dk_3',
			allowCookies: false,
			suggestions: {
				num: '5',
				minChars: '2',
				viewAllLabel: 'Vis alle resultater',
				searchHistoryLabel: 'Dine seneste søgninger:'
			},
			style: {
				searchBox: {
					button: {
						text: ' ',
						icon: 'magnifier',
						color: '#757575'
					}
				},
				accentColor: '#DD020E',
			},
			searchBox: {
				selector: '[data-search-page]',
				placeholder: 'Søg'
			},
			results: {
				caption: 'Din søgning for \'#QUERY#\' gav (#COUNT#) resultater',
				moreResultsButton: 'Vis flere resultater',
				noResultsText: 'Der blev ikke fundet nogen resultater',
				queryCorrectionText: 'Mente du \'#CORRECTION#\'?',
				queryCorrectionRewrite: 'Viser resultater for "#CORRECTION#"',
				orderByRelevanceText: 'Relevans',
				sortingLabel: 'Sortering:',
				sorting: this.sortingOption ? this.sortingOption : '',
				embedConfig: {
					contentBlock: '#ss360-results'
				},
				showSearchBoxLayover: false,
				searchQueryParamName: 'search'
			},
			contentGroups: {
				otherName: 'Andre'
			},
			specialMobileSuggest: {
				enabled: false
			},
			layout: {
				mobile: {
					showUrl: false,
					gridColsSm: 4,
					showSnippet: true
				},
				desktop: {
					showUrl: false,
					showSnippet: true
				},
				navigation: {
					allResultsTabName: 'Alle resultater',
					allResultsTabTitle: 'Alle resultater (#COUNT#)'
				}
			},
			filters: {
				enabled: true,
				deleteAllLabel: 'Ryd alle',
				toggleButtonLabel: 'Filtrer resultater',
				multiSelectSearchLabel: 'Søg i #FILTER_NAME#',
				clearGroupLabel: 'Ryd',
				multiSelectShowMoreLabel: 'Se #COUNT# mere',
				multiSelectShowLessLabel: 'Se færre muligheder'
			},
			accessibility: {
				searchFieldLabel: 'Søgeord',
				srSuggestionsHiddenText: 'Forslag til søgning er skjult',
				srNoSuggestionsText: 'Der er ingen forslag til søgningen',
				srSuggestionsCountText: '#COUNT# forslag vist',
				srOneSuggestionText: 'Et forslag til søgning vist',
				srSuggestBoxControlDescription: 'Brug op og ned piltaster for at navigere i resultaterne. Tryk enter for at gå til det valgte resultat. Ved brug af touch devices kan man anvende touch og swipe funktioner.'
			},
			showErrors: false,
			callbacks: {
				init: () => {
					const isOnSearchResultsPage = this.localSearchPage;
					const urlParams = new URLSearchParams(window.location.search);
					const searchParameter = urlParams.get('search');
					const noSearchPerformed = searchParameter === null || searchParameter === '';
					if (isOnSearchResultsPage && noSearchPerformed) {
						window.SS360.showResults('*');
					}
				},
				preSearch: (query, sort, selectedSearchBox) => {
					document.cookie = 'ss360CGResults= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';

					const searchPage = selectedSearchBox ? selectedSearchBox.get()[0].getAttribute('data-search-page') : '';

					if (searchPage === '') {
						window.SS360.changeConfig('results.embedConfig.url', window.location.href);

						const localSearchInput = this.localSearchPage;
						if (localSearchInput) {
							const contentGroup = localSearchInput.getAttribute('data-ss360-include').replace(/'/g, '"');
							window.SS360.changeConfig('contentGroups.include', JSON.parse(contentGroup));
						}
					} else {
						window.SS360.changeConfig('results.embedConfig.url', searchPage);
					}
					return true;
				}
			},
		};
		Search.setScript();
	}

	setEventListeners() {
		this.elm.querySelectorAll('#siteSearchBox').forEach((elm) => {
			const input = elm.getElementsByTagName('input');
			const inputIsLocal = input[0].getAttribute('data-ss360-include');
			if (!inputIsLocal) {
				input[0].addEventListener('keydown', (e) => {
					if (e.key === 'Enter') {
						this.handleClick();
					}
				});
				const button = elm.getElementsByTagName('button');
				button[0].addEventListener('click', () => {
					this.handleClick();
				});
			}
		});
	}

	handleClick() {
		setTimeout(() => {
			this.burgermenu.checked = false;
			this.publish('HEADER:TOGGLE');
		}, 100);
	}

	static setScript() {
		const e = document.createElement('script');
		e.async = !0;
		e.src = 'https://cdn.sitesearch360.com/v13/sitesearch360-v13.min.js';
		document.getElementsByTagName('body')[0].appendChild(e);
	}
}
export default Search;
